import React from 'react'
import { useField, useFormState } from 'react-final-form'
import styled from '@emotion/styled'
import { Text } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import { mq } from '../../helpers'

const MultiSelectField = React.forwardRef(
  (
    { name, placeholder, options, isSingleSelect = false, boldTitle = false },
    ref,
  ) => {
    const field = useField(name)
    const { submitFailed } = useFormState({ subscription: { submitFailed: true } })

    const { input } = field

    const handleSelect = (e) => {
      e.preventDefault()
      input.onFocus()

      const { value } = e.target

      if (isSingleSelect) {
        input.onChange(value)
      } else {
        const selected = input.value.includes(value)
          ? input.value.filter((v) => v !== value)
          : [...input.value, value]

        input.onChange(selected)

        // allows dom to finish onChange
        setTimeout(() => {
          input.onBlur()
        }, 0)
      }
    }

    return (
      <MultiSelectContainer ref={ref}>
        {placeholder ? (
          <Text className={boldTitle ? 'bold' : ''}>{placeholder}</Text>
        ) : null}
        <div className="options-container">
          {options.map((option, idx) => (
            <button
              key={idx}
              value={option}
              type="button"
              className={`service-option-button ${input?.value?.includes(option) ? 'selected' : ''}`}
              onClick={handleSelect}
            >
              {option}
            </button>
          ))}
        </div>
        {!!field?.meta?.error && submitFailed && (
          <Text color={gsColors.errorRed} margin="-14px 0 0 0">
            {field?.meta?.error || 'Required'}
          </Text>
        )}
      </MultiSelectContainer>
    )
  },
)

export default MultiSelectField

const MultiSelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;

  .bold {
    font-size: 18px;
    font-weight: 600;
    line-height: 120%;
    letter-spacing: 0.18px;
  }

  .options-container {
    display: flex;
    flex-direction: row;
    gap: 8px;

    ${mq('max', '768px')} {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .service-option-button {
      display: inline-block;
      background-color: transparent;
      border: 1px solid black;
      padding: 14px 24px;
      font-weight: bold;
      cursor: pointer;
      user-select: none;
      font-family: 'Euclid';
      color: black;
      font-size: clamp(12px, 2vw, 18px);
      font-style: normal;
      font-weight: 600;
      line-height: 100%;
      letter-spacing: 1.44px;
      cursor: pointer;
      box-sizing: border-box;

      &.error {
        border-color: ${gsColors.errorRed};
        color: ${gsColors.errorRed};
      }

      &.selected {
        background-color: ${gsColors.sunsetOrange};
        border: 1px solid ${gsColors.sunsetOrange};
        color: white;
      }
    }
  }
`
